import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import useHackathon from '@/data/hook/hackathon/useHackathon';
import useAuth from '@/data/hook/useAuth';
import { classNamePodium } from '@/utils/hackathon';
import ProjectPermissions from '@/utils/permissions/ProjectPermission';
import { twMerge } from 'tailwind-merge';
import Card from '../Card';
import ProjectCardProps from './ProjectCardProps';

export default function CreateRankingCard({
  project,
  rank,
  onMutate,
  className,
}: ProjectCardProps & { rank?: number }) {
  const { user } = useAuth();
  const { hackathon, isLoading } = useHackathon();
  const permissions = new ProjectPermissions({
    user,
    model: project,
    hackathon,
    isLoadingHackathon: isLoading,
  });

  return (
    <Card
      key={project.id}
      project={project}
      className={twMerge(className?.base, classNamePodium[rank || 4])}
    >
      <ConditionalRenderer condition={permissions.canInteract()}>
        <Card.Interactions project={project} onMutate={onMutate} />
      </ConditionalRenderer>
      <Card.Banner url={project.image} />
      <Card.FlexGroup>
        <Card.Title title={project.title} className="grow" />
        <Card.Ranking position={rank || 0} />
      </Card.FlexGroup>
      <Card.Tags tool={project.tool} flags={project.flags} />
      <Card.FlexGroup>
        <Card.PublushDate publishAt={project.createdAt} />
        <Card.Owners owners={project.users} />
      </Card.FlexGroup>
    </Card>
  );
}
